import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";

const REPRESENTS = [
    "Textile Machinery Importers", "Machinery Dealers", "Spare Parts Suppliers",
    "Technical Service Providers", "Installation & Commissioning Experts",
    "Maintenance Service Companies", "Textile Industry Consultants",
];

const OBJECTIVES = [
    { title: "Promote Industry Growth", desc: "Support the development of the textile machinery sector through collaboration and innovation." },
    { title: "Encourage Ethical Business Practices", desc: "Promote transparency, integrity, and professionalism among members." },
    { title: "Protect Industry Interests", desc: "Represent members before government authorities, regulators, and financial institutions." },
    { title: "Support Textile Manufacturers", desc: "Connect textile manufacturers with verified suppliers and technical experts." },
    { title: "Organize Industry Events", desc: "Conduct exhibitions, seminars, workshops, and networking programs." },
    { title: "Prevent Unethical Practices", desc: "Create awareness against fake quotations, misleading claims, and fraudulent business activities." },
    { title: "Develop Industry Standards", desc: "Establish best practices for machinery supply, installation, and after-sales service." },
];

const CONDUCT = [
    "Maintain ethical business practices.",
    "Provide accurate information.",
    "Avoid fake quotations.",
    "Honor commercial commitments.",
    "Respect fellow members.",
    "Follow Association Rules & Regulations.",
];

export default function About() {
    return (
        <div className="min-h-screen flex flex-col">
            <PublicHeader />

            {/* HERO */}
            <section className="bg-[#0F172A] text-white">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">About the Federation</div>
                    <h1 className="font-display text-4xl lg:text-6xl font-bold tracking-tight max-w-4xl">A professional organization dedicated to the advancement of the textile machinery industry.</h1>
                </div>
            </section>

            {/* REPRESENTS */}
            <section data-testid="about-represents" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 grid md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">About STMF Association</div>
                    <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#0F172A] leading-tight">The Association represents:</h2>
                </div>
                <div className="md:col-span-7">
                    <div className="grid sm:grid-cols-2 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
                        {REPRESENTS.map((r, i) => (
                            <div key={r} className="bg-white p-5 flex items-center gap-3" data-testid={`represents-${i}`}>
                                <span className="font-mono text-xs text-[#D4AF37]">{String(i + 1).padStart(2, "0")}</span>
                                <span className="text-sm text-[#0F172A] font-medium">{r}</span>
                            </div>
                        ))}
                    </div>
                    <p className="mt-6 text-[#64748B] leading-relaxed">By bringing together industry professionals under one platform, STMF promotes cooperation, discipline, and standardization across the textile machinery ecosystem.</p>
                </div>
            </section>

            {/* OBJECTIVES */}
            <section className="bg-[#F8F9FA] border-y border-[#E2E8F0]">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Our Objectives</div>
                    <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#0F172A] leading-tight mb-14 max-w-3xl">Seven commitments to the industry we serve.</h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
                        {OBJECTIVES.map((o, i) => (
                            <div key={o.title} data-testid={`objective-${i}`} className="bg-white p-8">
                                <div className="font-mono text-xs text-[#D4AF37] mb-4">{String(i + 1).padStart(2, "0")}</div>
                                <h3 className="font-display text-lg font-bold text-[#0F172A] mb-2">{o.title}</h3>
                                <p className="text-sm text-[#64748B] leading-relaxed">{o.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CODE OF CONDUCT */}
            <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24 grid md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Code of Conduct</div>
                    <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#0F172A] leading-tight">Every STMF member commits to:</h2>
                </div>
                <div className="md:col-span-7">
                    <ul className="divide-y divide-[#E2E8F0] border-y border-[#E2E8F0]">
                        {CONDUCT.map((c, i) => (
                            <li key={c} data-testid={`conduct-${i}`} className="py-5 flex items-center gap-5">
                                <span className="font-mono text-xs text-[#D4AF37] w-8">{String(i + 1).padStart(2, "0")}</span>
                                <span className="text-[#0F172A] font-medium">{c}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <PublicFooter />
        </div>
    );
}
